import { merge } from "solid-js";
import type { Renderer, RendererOptions } from "./universal.ts";
import { createRenderer as createUniversalRenderer } from "./universal.ts";

export type { Renderer, RendererOptions };

export function createRenderer<NodeType>(
	options: RendererOptions<NodeType>,
): Renderer<NodeType> {
	const renderer = createUniversalRenderer(options);
	renderer.mergeProps = merge;
	return renderer;
}
